"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WELCOME_GUIDE_COPY = void 0;
exports.welcomeGuideHostOpens = welcomeGuideHostOpens;
/**
 * The welcome box: when the app shell may open it, and what it says. Shared by
 * web and mobile (BEN-141 X4 and its mobile parity).
 *
 * THE HOST OPENS ONLY AFTER SETUP. Both apps have routes a user reaches before
 * finishing setup that sit inside the shell where the host lives: web signup ends
 * on /payment; mobile reaches /(drawer)/payment on a 402 while the paywall is on,
 * and from a failed Stripe return. Without this, the after-setup box opened over
 * the payment page with cards the setup gate bounced straight back. `undefined`
 * (profile not loaded) counts as not finished.
 *
 * NOT WHILE PAYWALLED (paywall rehearsal, 2026-10-15). With gating on, an onboarded
 * account with no plan lands on the plan page, and the box opened over it, covering
 * "Start free trial" with cards for pages the paywall refuses. That is every existing
 * unpaid user on the day of the flip. `paywalled` is optional so a caller that cannot
 * tell keeps the old rule.
 */
function welcomeGuideHostOpens(state) {
    return (state.ready &&
        !state.dismissed &&
        !state.alreadySeen &&
        state.onboardingComplete === true &&
        state.paywalled !== true);
}
/**
 * The box's words for each form. Inside setup it lists the steps ahead, numbered.
 * After setup it is navigation: nothing on it calls itself a tour or a step, and
 * its cards are named after the page they open (each app names its own pages).
 */
exports.WELCOME_GUIDE_COPY = {
    // No description: inside setup the box says SETUP_INTRO_COPY (AN-35: no count,
    // so the two apps can't disagree about it).
    setup: {
        title: "Welcome to Fomo-Fi 🎉",
        section: "Here’s what will happen",
    },
    afterSetup: {
        title: "Welcome to Fomo-Fi 🎉",
        description: "Here’s where everything lives. Open any of these whenever you like.",
        section: "Where to find things",
    },
};
//# sourceMappingURL=welcomeGuide.js.map